import { SB, createMessage } from '@play-co/replicant';
import createMessages from './createMessages';

export const deprecatedMessages = createMessages({
  /**
   * @deprecated `state.isOnline` is unused: visit availability comes from the
   * Replicant Presence API (#11159). Kept registered so queued messages from old
   * clients do not fail.
   */
  setOnline: createMessage(SB.boolean(), () => {
    // NOOP
  }),

  /**
   * @deprecated `chatbotMessagesSinceLastSession` was removed in favor of
   * `receivedMessagesSinceLastEntry`.
   */
  updateChatbotMessagesSinceLastSession: createMessage(SB.object({}), () => {
    // NOOP
  }),

  /**
   * @deprecated The `messageBreadcrumbs`/`messageBreadcrumbsCount` analytics
   * properties were removed from `EntryFinal`. Kept registered so queued
   * messages from old clients do not fail.
   */
  updateMessagesAnalytics: createMessage(
    SB.object({ $subFeature: SB.string() }),
    () => {
      // NOOP
    },
  ),

  // ===== Rescue Quest Messages (feature removed) =====

  /**
   * @deprecated Rescue quest feature has been removed.
   * Receive an invite from a player.
   */
  rescueQuestReceiveInvite: createMessage(
    SB.object({ name: SB.string(), photo: SB.string() }),
    () => {
      // NOOP
    },
  ),

  /**
   * @deprecated Rescue quest feature has been removed.
   * Decline or cancel an invite.
   */
  rescueQuestDeleteInvite: createMessage(SB.object({}), () => {
    // NOOP
  }),

  /**
   * @deprecated Rescue quest feature has been removed.
   * Player accepted the invite.
   */
  rescueQuestInviteAccepted: createMessage(
    SB.object({ name: SB.string(), photo: SB.string() }),
    () => {
      // NOOP
    },
  ),

  /**
   * @deprecated Rescue quest feature has been removed.
   * Update participant level progress.
   */
  rescueQuestUpdateParticipantLevel: createMessage(
    SB.object({
      participantId: SB.string(),
      eventId: SB.string(),
      completedLevels: SB.int(),
    }),
    () => {
      // NOOP
    },
  ),

  // ===== Happiness Booster Messages (feature removed) =====

  /**
   * @deprecated Happiness booster feature has been removed.
   * Save received happiness booster interaction.
   */
  happinessBoosterReceive: createMessage(SB.object({}), () => {
    // NOOP
  }),

  // ===== Boost Rocket Messages (feature removed) =====

  /**
   * @deprecated Boost Rocket feature has been removed (#11759).
   * Receive a party invite from a player.
   */
  boostRocketAddInviteReceived: createMessage(SB.object({}), () => {
    // NOOP
  }),

  /**
   * @deprecated Boost Rocket feature has been removed (#11759).
   * Sender cancelled a party invite.
   */
  boostRocketRemoveInvite: createMessage(SB.object({}), () => {
    // NOOP
  }),

  /**
   * @deprecated Boost Rocket feature has been removed (#11759).
   * A player joined the party.
   */
  boostRocketAddPlayerToParty: createMessage(
    SB.object({ initialScore: SB.int().optional() }),
    () => {
      // NOOP
    },
  ),

  /**
   * @deprecated Boost Rocket feature has been removed (#11759).
   * A party member contributed to the shared score.
   */
  boostRocketAddPartyPlayerScore: createMessage(
    SB.object({ score: SB.int() }),
    () => {
      // NOOP
    },
  ),

  /**
   * @deprecated Boost Rocket feature has been removed (#11759).
   * Receiver declined a party invite.
   */
  boostRocketDeclineInviteNotify: createMessage(SB.object({}), () => {
    // NOOP
  }),

  // ===== Fairy Forest Messages (feature removed) =====

  /**
   * @deprecated Fairy Forest feature has been removed (#11760).
   * Update the partner score in the current event.
   */
  fairyForestUpdatePartnerScore: createMessage(
    SB.object({ score: SB.number() }),
    () => {
      // NOOP
    },
  ),

  /**
   * @deprecated Fairy Forest feature has been removed (#11760).
   * Receive an invite from a player.
   */
  fairyForestReceiveInvite: createMessage(
    SB.object({
      name: SB.string(),
      photo: SB.string(),
      frame: SB.string().optional(),
    }),
    () => {
      // NOOP
    },
  ),

  /**
   * @deprecated Fairy Forest feature has been removed (#11760).
   * Decline or cancel an invite.
   */
  fairyForestDeleteInvite: createMessage(SB.object({}), () => {
    // NOOP
  }),

  /**
   * @deprecated Fairy Forest feature has been removed (#11760).
   * Accept an invite from a player.
   */
  fairyForestAcceptInvite: createMessage(SB.object({}), () => {
    // NOOP
  }),
});
